/**
 * This behavior listens for the `clipboard-copy` event and toggles the
 * style of it along with any icons.
 *
 * The `clipboard-copy` component should be used to trigger this behavior.
 */
import { on } from "delegated-events";
import { addClasses, parseClassList, removeClasses, } from "../utils/classes";
// How long the copied state should be shown for
const duration = 4000;
function toggleIcons(button, state) {
    const copyIcon = button.querySelector(".js-clipboard-copy-icon");
    const checkIcon = button.querySelector(".js-clipboard-check-icon");
    if (state === "check") {
        copyIcon === null || copyIcon === void 0 ? void 0 : copyIcon.classList.add("hidden");
        checkIcon === null || checkIcon === void 0 ? void 0 : checkIcon.classList.remove("hidden");
    }
    else {
        copyIcon === null || copyIcon === void 0 ? void 0 : copyIcon.classList.remove("hidden");
        checkIcon === null || checkIcon === void 0 ? void 0 : checkIcon.classList.add("hidden");
    }
}
on("clipboard-copy", "[data-copy-feedback]", (event) => {
    // TODO: The value of `data-copy-feedback` needs to be announced to screen readers
    const copyEvent = event;
    const target = copyEvent.target;
    const defaultClasses = parseClassList(target.getAttribute("default-class"));
    const copiedClasses = parseClassList(target.getAttribute("copied-class"));
    removeClasses(target, ...defaultClasses);
    addClasses(target, ...copiedClasses);
    toggleIcons(target, "check");
    setTimeout(() => {
        removeClasses(target, ...copiedClasses);
        addClasses(target, ...defaultClasses);
        toggleIcons(target, "copy");
    }, duration);
});
